module.exports = __webpack_public_path__ + "static/media/glauser.09e637d4.png";